import React from 'react';

import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { AlertIcon } from '../../../common-components/elements/icon/svgs/AlertIcon';

const AlertIconContainer = styled.div`
  color: red;
  position: absolute;
  top: 5%;
  left: 5%;
`;

const useStyles = makeStyles(() => ({
  modelErrorTooltip: {
    zIndex: 10,
  },
}));

interface Props {
  modelErrorMessage?: string;
  variant: 'thumbnail' | 'regular';
}

export const ModelErrorIcon: React.FC<Props> = ({
  modelErrorMessage,
  variant,
}) => {
  const classes = useStyles();

  return (
    <Tooltip
      title={modelErrorMessage}
      arrow
      className={classes.modelErrorTooltip}
    >
      <AlertIconContainer className={variant}>
        <AlertIcon />
      </AlertIconContainer>
    </Tooltip>
  );
};
